import { SelectionFeature, mapStore } from "../store";

import { cleanTypenameRetainFunctionProps } from "react-migration/lib/util/cleanTypename";
import { navigateToGeometry } from "react-migration/lib/util/navigateToGeometry";
import { ref } from "valtio";
import { updateShowWorkbench } from "./updateShowWorkbench";

export function updateSelection(selection?: SelectionFeature) {
  const newSelection = selection ? ref(cleanTypenameRetainFunctionProps(selection)) : undefined;
  const showWorkbench = !!newSelection;

  mapStore.selection = newSelection;

  updateShowWorkbench(showWorkbench);

  // TODO: Review if we want to release this functionality on desktop after mobile release
  // UPD: Adding this for desktop by Aaron's request (Vlad Khapalov, 02.09.2025)
  if (selection?.feature?.properties?.fromUrl) {
    navigateToGeometry({ geometry: selection?.feature?.geometry, googleMap: mapStore.googleMap });
  }
}
